var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H3M6 17H5",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.829 18H23v-6l-4-2-1-4h-8v12h2.171",
    fill: "#EF69A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.829 18H23v-6l-4-2-1-4h-8v12h2.171",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7h5M1 2h9v4M15 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM14 9v2h2",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default SvgTruck;